import { Component, Input, OnInit, Optional, Inject } from '@angular/core';
import { PortalComponentConstants } from '../utils/portal-component.constants';
import { PermissionCheckerService } from '@pershing/pershing-core';
import { Location } from '@angular/common';

@Component({
    selector: 'nxi-f2-component',
    templateUrl: './nxi-f2.component.html'
})
export class NxiF2Component implements OnInit {
    /*
	* This component should take id and data-params as input
	* This component will be used to as simple component expecting multiple entry in siteconfig.json file
    */
    container: any;
    @Input() id: string;
    @Input() class: string;
    @Input() dataParams: string;
    @Input() entitlement: string;
    isEntitledforView: boolean;
    currentView: string;
    isAdaTheme: boolean = false;
    appSettings: any;

    constructor(@Optional() @Inject('AppSettings') appSettings: any, private authService: PermissionCheckerService, private location: Location) {
        this.appSettings = appSettings;
    }
    ngOnInit() {
        if (this.entitlement !== undefined) {
            this.isEntitledforView = this.authService.isEntitled(this.entitlement);
        } else {
            this.isEntitledforView = true;
        }
        this.currentView = this.getViewName();
        if (this.appSettings.themeType && this.appSettings.themeType === 'ada' &&
            (PortalComponentConstants.AdaPageContentIgnoreList.indexOf(this.currentView) === -1) &&
            (PortalComponentConstants.AdaComponentIgnoreList.indexOf(this.id) === -1)) {
            this.isAdaTheme = true;
        }
    }

    getViewName() {
        let url = this.location.path(false);
        let urlArray = url.split('/');
        if (urlArray[urlArray.length - 1].split('?').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('?')[0];
        }
        if (urlArray[urlArray.length - 1].split('#').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split('#')[0];
        }
        if (urlArray[urlArray.length - 1].split(';').length > 1) {
            urlArray[urlArray.length - 1] = urlArray[urlArray.length - 1].split(';')[0];
        }
        return urlArray[urlArray.length - 1];
    }
}
